import styled from "styled-components";

export const Credential = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #52555d;
  font-size: 14px;
  font-weight: 400;
  background-color: #ffffff;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  box-sizing: border-box;
  height: 40px;
  padding: 0px 16px;
`;

export const CopyButton = styled.div`
  color: #4957d2;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  position: relative;
`;

export const Tooltip = styled.span`
  position: absolute;
  // Because the CopyButton has a height of 17px and then 20px separation
  top: -37px;
  // Center within CopyButton text
  left: -8px;
  width: 55px;
  height: 27px;
  display: none; // Should be set to flex once desired to display
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 6px;
  font-size: 12px;
  color: #ffffff;

  ::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    position: absolute;

    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid rgba(0, 0, 0, 0.7);
    transform: rotate(-90deg);
    top: 23px;
  }
`;
